import React from 'react';

//CONSTANTS
import { FOOTER_YEAR } from '../../appConfig';

// IMPORT STYLES
import './Footer.css';

function Footer() {

  return(
    <div className='footer'>
      <p className='footer__text'>&#169; {FOOTER_YEAR} Флоренская Психолог.</p>
    </div>
  );
}
export default Footer;
